//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const DataScienceHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background">

      <Box background="url('/images/textures/hpe-tech-surface.jpg')" height="140px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '5px', bottom: '10px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Data Science @ HPE</Text>} 
                          subtitle={"Driving impact through Data Science and AI"}
                          style={{ color: 'white' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Coming soon...</Heading>

      </PageContent>  

    </Page>
  );
};